module.exports = __webpack_public_path__ + "img/img07.cce5ae21.png";